
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError, retryWhen } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { CalAngularService } from '@cvx/cal-angular';
import { SessionRefreshDialogComponent } from '../_shared/session-refresh-dialog/session-refresh-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private requests: HttpRequest<any>[] = [];
  scopes: string[] = [];
  constructor(private spinnerServiceNew: NgxSpinnerService, private router: Router, private authService: CalAngularService, public dialog: MatDialog) {
    this.scopes = environment.calConfig.scopes;
  }


  removeRequest(req: HttpRequest<any>) {
    let tempReq = this.requests;
    if (this.requests && this.requests.length > 0) {
      this.requests.forEach(function (value, index) {
        if (value.url == req.url) {
          tempReq.splice(index, 1); // This removes the request from our array
        }
      });
    }

    if (tempReq.length == 0) { //&& req.url.indexOf('/Auth') == -1
      // this.spinnerService.Spinner("hide");
      if (req.method === 'POST' && req.url.includes('/upload')) {
        this.spinnerServiceNew.show();
      }
      else {
        this.spinnerServiceNew.hide();
       } 
      }
     else {
      this.spinnerServiceNew.hide();
     }

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinnerServiceNew.show();

    let tokenFound = false;
    let token = "";
    let expiryDate = 0;
    let requireTokenRefresh = false;

    for (let keyt in localStorage) {
      try {
        let AccessObj = JSON.parse(localStorage[keyt])
        if (environment.calConfig.scopes.includes(AccessObj["target"])) {
          tokenFound = true;
            token = AccessObj["secret"];
            expiryDate = AccessObj["expiresOn"] * 1000;
    
            if(((expiryDate - (Date.now()/1)) / 60000) < 10){
            requireTokenRefresh = true;
          }
        }
      } catch (e) {
      }
    }

    if (tokenFound) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    if (requireTokenRefresh) {
      this.authService.getAADToken(this.scopes)
        .subscribe(tokenProperty => {
        });
    }


    this.requests.push(request);
    return new Observable(observer => {
      // And subscribe to the original observable to ensure the HttpRequest is made
      const subscription = next.handle(request)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(request);
              observer.next(event);
            }
            //this.spinnerServiceNew.hide();
          },
          err => {

            if (err.status == 401) {
              if (err instanceof HttpErrorResponse && err.status == 401) {
                this.authService.getAADToken(this.scopes)
                  .subscribe(tokenProperty => {
                    const authReq = request.clone({
                      setHeaders: {
                        Authorization: `Bearer ${token}`
                      }
                    });

                    setTimeout(() => {
                      this.spinnerServiceNew.hide();
                    }, 300);
                    const currentUser = localStorage.getItem('currentUser');
                    if (this.dialog.openDialogs.length === 0) {
                    if (currentUser && currentUser !== "undefined") {
                      const dialogRef = this.dialog.open(SessionRefreshDialogComponent);
                      dialogRef.componentInstance.displayModal = true;
                      dialogRef.componentInstance.onContinue.subscribe((data) => {
                        if (data.isContinue) {
                          this.dialog.closeAll();
                        }
                      });
                    }
                  }
                    return next.handle(authReq);
                  });


              }

            }

            else  //if (err.status == 500) {
            {
              this.router.navigate(['/Error'])
              this.removeRequest(request);
              observer.error(err);
            }
          },
          () => { this.removeRequest(request); observer.complete(); }
        );
      // return teardown logic in case of cancelled requests
      return () => {
        this.removeRequest(request);
        subscription.unsubscribe();
      };
    });
  }
}